/**
* 个人实名认证
*/
<template>
	<div class="min-h-screen bg-gray-50 flex items-center justify-center py-5 px-4"
		style="padding-left: 5%; padding-right: 5%;">

		<!-- css样式库 -->
		<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
		<!-- 图标库 -->
		<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">

		<div>
			<div class="flex flex-col space-y-8 ">

				<!-- 认证流程说明 start -->
				<div class="bg-white rounded-lg shadow-sm p-8">
					<h3 class="text-lg font-medium mb-6">{{ $t('language000124') }}</h3>
					<div class="grid grid-cols-3 gap-8">
						<div v-for="(step, index) in certificationSteps" :key="index" class="text-center">
							<div
								class="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center mx-auto mb-4">
								<i :class="step.icon" class="text-blue-600 text-xl"></i>
							</div>
							<h4 class="font-medium mb-2">{{ step.title }}</h4>
							<p class="text-gray-500 text-sm">{{ step.description }}</p>
						</div>
					</div>
				</div>
				<!-- 认证流程说明 end -->


				<!-- 个人实名认证区域 start -->
				<div class="bg-white rounded-lg shadow-lg p-8">
					<h2 class="text-2xl font-bold mb-6">
						<!-- 个人实名认证 -->
						{{ $t('language000133') }}
					</h2>
					<div class="space-y-6">
						<!-- 姓名输入 -->
						<div class="space-y-2">
							<label class="block text-gray-700">
								<!-- 姓名 -->
								{{ $t('language000134') }}
							</label>
							<input type="text" v-model="personalForm.name"
								class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
								:placeholder="$t('language000135')" />
						</div>

						<!-- 身份证号码输入 -->
						<div class="space-y-2">
							<label class="block text-gray-700">
								<!-- 身份证号码 -->
								{{ $t('language000136') }}
							</label>
							<input type="text" v-model="personalForm.idNumber"
								class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
								:placeholder="$t('language000137')" />
						</div>

						<!-- 身份证照片上传 -->
						<div class="space-y-4">
							<label class="block text-gray-700">{{ $t('language000138') }}</label>
							<div class="grid grid-cols-2 gap-4">
								<!-- 正面照片 -->
								<div class="relative">
									<div class="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center cursor-pointer hover:border-blue-500 transition-colors"
										@click="triggerUpload('front')">
										<div v-if="!personalForm.frontImage" class="space-y-2">
											<i class="fas fa-id-card text-4xl text-gray-400"></i>
											<p class="text-sm text-gray-500">
												<!-- 上传身份证正面照片 -->
												{{ $t('language000139') }}
											</p>
										</div>
										<img v-else :src="personalForm.frontImage"
											class="w-full h-48 object-cover rounded-lg" alt="身份证正面" />
									</div>
									<input type="file" ref="frontImageInput" class="hidden" accept="image/*"
										@change="handleImageUpload('front', $event)" />
								</div>

								<!-- 反面照片 -->
								<div class="relative">
									<div class="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center cursor-pointer hover:border-blue-500 transition-colors"
										@click="triggerUpload('back')">
										<div v-if="!personalForm.backImage" class="space-y-2">
											<i class="fas fa-id-card text-4xl text-gray-400"></i>
											<p class="text-sm text-gray-500">
												<!-- 上传身份证反面照片 -->
												{{ $t('language000140') }}
											</p>
										</div>
										<img v-else :src="personalForm.backImage"
											class="w-full h-48 object-cover rounded-lg" alt="身份证反面" />
									</div>
									<input type="file" ref="backImageInput" class="hidden" accept="image/*"
										@change="handleImageUpload('back', $event)" />
								</div>
							</div>
						</div>

						<!-- 提交按钮 -->
						<button @click="submitPersonalVerification"
							class="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition-colors !rounded-button whitespace-nowrap">
							<!-- 提交认证 -->
							{{ $t('language000141') }}
						</button>


						<!-- 企业认证升级区域 start -->
						<div class="bg-gray-100 rounded-lg shadow-sm p-8">
							<div class="flex items-start">
								<div class="w-12 h-12 mr-6 flex-shrink-0">
									<div class="w-full h-full bg-gray-100 rounded-lg flex items-center justify-center">
										<i class="fas fa-building text-gray-400 text-xl"></i>
									</div>
								</div>

								<div class="flex-1">
									<h2 class="text-xl font-medium mb-4">
										<!-- 升级为企业认证 -->
										{{ $t('language000142') }}
									</h2>
									<p class="text-gray-600 mb-6 leading-relaxed">
										<!-- 企业认证后可享受更多权益，包括： -->
										{{ $t('language000143') }}
									</p>
									<ul class="mb-8">
										<li class="flex items-center text-gray-600 mb-2">
											<i class="fas fa-check text-green-500 mr-2"></i>
											<!-- 不限制 API 调用量 -->
											{{ $t('language000144') }}
										</li>
										<li class="flex items-center text-gray-600 mb-2">
											<i class="fas fa-check text-green-500 mr-2"></i>
											<!-- 专属技术支持服务 -->
											{{ $t('language000145') }}
										</li>
										<li class="flex items-center text-gray-600">
											<i class="fas fa-check text-green-500 mr-2"></i>
											<!-- 更多高级功能权限 -->
											{{ $t('language000146') }}
										</li>
									</ul>

									<button
										class="!rounded-button whitespace-nowrap bg-blue-600 text-white px-6 py-2.5 text-sm hover:bg-blue-700 transition-colors"
										@click="handleUpgrade">
										<!-- 立即升级 -->
										{{ $t('language000147') }}
									</button>
								</div>
							</div>
						</div>
						<!-- 企业认证升级区域 end -->

					</div>

				</div>
				<!-- 个人实名认证区域 end -->



			</div>
		</div>


	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		mounted() {
			// 在生命周期钩子中获取路由参数

			const userLanguage = navigator.language || navigator.userLanguage; // 获取用户浏览器所配置的语言偏好
			const isLanguageSupported = this.$p_languages.includes(userLanguage); // 检查用户语言是否在支持的语言列表中
			this.$i18n.locale = isLanguageSupported ? userLanguage : this.$p_defaultLanguage; // 如果语言受支持，则设置为用户语言，否则设置为默认语言
			//this.$i18n.locale = 'en'; // 设置为英语
		},
		data() {
			return {
				personalForm: {
					name: '',
					idNumber: '',
					frontImage: '',
					backImage: '',
				},
				frontImageInput: null,
				backImageInput: null,
				frontImageHttp: '', //身份证正面
				backImageHttp: '', //身份证反面
			};
		},
		computed: {
			certificationSteps() {
				return [{
						icon: 'fas fa-file-alt',
						title: this.$t('language000125'), //准备材料
						description: this.$t('language000126'), //准备营业执照、法人身份证等认证所需材料
					},
					{
						icon: 'fas fa-upload',
						title: this.$t('language000127'), //提交审核
						description: this.$t('language000128'), //上传相关证件照片，提交审核
					},
					{
						icon: 'fas fa-check-circle',
						title: this.$t('language000129'), //完成认证
						description: this.$t('language000130'), //等待 1-3 个工作日完成审核，审核通过即可认证成功
					}
				];
			},
			//...
		},
		methods: {
			triggerUpload(type) {
				if (type === 'front') {
					this.$refs.frontImageInput.click();
				} else {
					this.$refs.backImageInput.click();
				}
			},
			handleImageUpload(type, event) {
				const target = event.target;
				const file = target.files[0]; // 获取上传的文件

				if (file) {
					const reader = new FileReader();
					reader.onload = (e) => {
						if (type === 'front') {
							this.personalForm.frontImage = e.target.result; // 显示预览
						} else {
							this.personalForm.backImage = e.target.result; // 显示预览
						}
					};
					reader.readAsDataURL(file);

					const formData = new FormData(); // 创建一个 FormData 对象
					formData.append("multipart", file); // 将文件添加到 FormData 对象中
					axios.post(this.$p_url_shop + '/api/front/upload/qiuiUploadImage?model=user&pid=1',
							formData, { //上传图片
								withCredentials: true,
								headers: {
									'Content-Type': 'multipart/form-data', //设置为上传文件的类型
								},
							})
						.then(response => {
							console.log("上传图片的返回：", response.data)
							const state = response.data.code; // 获取状态
							if (state === 200) { // 检查状态
								if (type === 'front') {
									this.frontImageHttp = response.data.data.url; //图片地址 身份证正面
									console.log("身份证正面：", this.$p_urlImage + this.frontImageHttp)
								} else {
									this.backImageHttp = response.data.data.url; //图片地址 身份证反面
									console.log("身份证反面：", this.$p_urlImage + this.backImageHttp)
								}
							} else {
								alert("服务器错误:" + response.data.message)
							}
						})
						.catch(error => { // 请求失败时处理错误
							alert('请求失败:' + error);
							console.error('Error fetching data:', error);
						});

				}
			},
			submitPersonalVerification() {
				// 实现提交逻辑
				console.log('提交个人认证信息:', this.personalForm);
			},
			handleUpgrade() {
				let pageA = this.$router.resolve({
					path: '/EnterpriseRealName',
					query: {}
				});
				window.open(pageA.href, '_blank');
			},
			//...
		},
	};
</script>

<style scoped>
	.container {
		min-height: 1024px;
	}

	input[type="number"]::-webkit-inner-spin-button,
	input[type="number"]::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
</style>